<ng-container *ngIf="!flatAttribute?.isComplexField">
  <div class="editor-container" *ngIf="!flatAttribute?.isDocument">
    <div
      *ngIf="!isEditing"
      class="attribute-display-container regular"
      fxLayout="row"
      fxLayoutAlign="space-between"
      (click)="openEditor()"
    >
      <div class="attribute-display-item" fxLayout="column" fxFlex="70">
        <b
          class="attribute-name"
          [innerHTML]="(useDescription ? flatAttribute?.description : flatAttribute?.name) | safeHtml"
        ></b>
        <ng-container *ngIf="flatAttribute?.isSkill">
          <skill [selectedSkillLevel]="firstElementValueListItem"></skill>
        </ng-container>
        <ng-container *ngIf="flatAttribute?.isStarRating">
          <app-star-rating-attribute [selectedStarRating]="firstElementValueListItem"></app-star-rating-attribute>
        </ng-container>
        <ng-container *ngIf="flatAttribute?.isLongAnswer">
          <div
            class="attribute-long-answer"
            *ngFor="let attribute of flatAttribute?.attributes"
            [innerHTML]="attribute.value | safeHtml"
          ></div>
        </ng-container>
        <ng-container *ngIf="flatAttribute?.isEncryptedField">
          <span class="attribute-value">{{ encryptedFieldValue }}</span>
        </ng-container>
        <ng-container
          *ngIf="
            !flatAttribute?.isSkill &&
            !flatAttribute?.isStarRating &&
            !flatAttribute?.isLongAnswer &&
            !flatAttribute?.isEncryptedField
          "
        >
          <span *ngFor="let value of flatAttribute?.attributes" class="attribute-value">{{
            formatDisplayValue(value)
          }}</span>
        </ng-container>

        <span *ngIf="!flatAttribute?.hasAttributes && editable" class="attribute-value-no-value">{{
          noValueText
        }}</span>
      </div>
      <div fxLayout="row" fxFlex="30" fxLayoutAlign="end center">
        <button mat-icon-button *ngIf="editable">
          <mat-icon aria-label="Edit" class="edit-icon mat-icon material-icons md-18">edit</mat-icon>
        </button>
        <button
          appThrottleClick
          mat-icon-button
          *ngIf="
            (!flatAttribute?.isEncryptedField && flatAttribute?.hasAttributes) ||
            (flatAttribute?.isEncryptedField && flatAttribute?.adminDocumentation)
          "
          (click)="showHistoricalText()"
        >
          <mat-icon
            matTooltip="{{ getInfoTooltipText() }}"
            matTooltipPosition="before"
            class="edit-icon mat-icon material-icons md-18"
            [class.yellow]="isStale()"
            attr.aria-label="{{ getInfoTooltipText() }}"
            >info</mat-icon
          >
        </button>
        <button
          appThrottleClick
          mat-icon-button
          matTooltip="{{ showPassword ? 'Hide value' : 'Show value' }}"
          matTooltipPosition="before"
          *ngIf="flatAttribute?.isEncryptedField && flatAttribute?.hasAttributes && isProfileEditorMode()"
          (click)="togglePasswordVisibility(flatAttribute.values)"
        >
          <mat-icon class="edit-icon mat-icon material-icons md-18">{{ visibility_icon }}</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="isEditing" class="attribute-editor-container">
      <attributes-editor (blurred)="doSave($event)" [mode]="attributeEditorMode" [dataSource]="editorDataSource"></attributes-editor>
      <div class="button-container">
        <button
          mat-button
          color="primary"
          [disabled]="!formIsValid() || isSaving"
          appThrottleClick
          (throttledClick)="doSave()"
        >
          <mat-icon>check</mat-icon> Save
        </button>
        <button type="button" mat-button (mousedown)="preventDefault($event)" (click)="cancel()">
          <mat-icon>close</mat-icon> Cancel
        </button>
      </div>
    </div>
  </div>
  <div class="editor-container document-attribute" *ngIf="flatAttribute?.isDocument">
    <div *ngIf="!isEditing" class="attribute-display-container" fxLayout="row" fxLayoutAlign="space-between">
      <div class="attribute-display-item" fxLayout="column" fxFlex="95">
        <b
          class="attribute-name"
          [innerHTML]="(useDescription ? flatAttribute?.description : flatAttribute?.name) | safeHtml"
        ></b>
        <div *ngIf="flatAttribute?.hasAttributes && editable" class="document-present">
          <div *ngFor="let attribute of flatAttribute?.attributes" class="attribute-value">
            <app-custom-document-viewer
              *ngIf="flatAttribute?.hasAttributes"
              [documentAttribute]="attribute"
              [entityType]="customField.entityType"
            ></app-custom-document-viewer>
          </div>
        </div>
        <div
          *ngIf="!flatAttribute?.hasAttributes && editable"
          class="document-absent"
          appThrottleClick
          (throttledClick)="openEditor()"
        >
          <span class="attribute-value-no-value">{{ noValueText }}</span>
        </div>
      </div>
      <div *ngIf="flatAttribute?.hasAttributes && editable" class="button-container document-edit-button">
        <button *ngIf="editable" mat-button color="primary" appThrottleClick (throttledClick)="openEditor()">
          <mat-icon>edit</mat-icon> Edit
        </button>
      </div>
    </div>

    <div *ngIf="isEditing" class="attribute-editor-container">
      <attributes-editor
        (blurred)="doSave($event, true)"
        [dataSource]="editorDataSource"
        [mode]="attributeEditorMode"
        [entityId]="entityId"
      ></attributes-editor>
      <div class="button-container">
        <button type="button" mat-button (mousedown)="preventDefault($event)" (click)="cancel()">
          <mat-icon>close</mat-icon> Close
        </button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="flatAttribute?.isComplexField">
  <div class="editor-container">
    <div
      *ngIf="!isEditing"
      class="attribute-display-container regular"
      fxLayout="row"
      fxLayoutAlign="space-between"
      appThrottleClick
      (throttledClick)="openEditor()"
    >
      <div class="attribute-display-item" fxLayout="column" fxFlex="80">
        <b
          class="attribute-name"
          [innerHTML]="(useDescription ? flatAttribute?.description : flatAttribute?.name) | safeHtml"
        ></b>
        <div *ngIf="flatAttribute?.hasComplexAttributeValues" class="document-present">
          <div *ngFor="let complexAttributeValue of flatAttribute?.complexAttributeValues" class="attribute-value">
            <app-complex-field-viewer [complexAttributeValue]="complexAttributeValue"></app-complex-field-viewer>
          </div>
        </div>
        <div *ngIf="!flatAttribute?.hasComplexAttributeValues" class="document-absent">
          <span class="attribute-value-no-value">{{ noValueText }}</span>
        </div>
      </div>
      <div class="icon-container">
        <mat-icon
          aria-label="Edit"
          class="edit-icon mat-icon material-icons md-18"
          *ngIf="editable && !flatAttribute?.hasComplexAttributeValues"
          >edit</mat-icon
        >
        <button appThrottleClick mat-icon-button (click)="showHistoricalText()">
          <mat-icon
            *ngIf="flatAttribute?.hasComplexAttributeValues"
            matTooltip="{{ getInfoTooltipText() }}"
            matTooltipPosition="before"
            class="edit-icon mat-icon material-icons md-18"
            [class.yellow]="isStale()"
            attr.aria-label="{{ getInfoTooltipText() }}"
            >info</mat-icon
          >
        </button>
      </div>
      <div *ngIf="flatAttribute?.hasComplexAttributeValues" class="button-container document-edit-button">
        <button *ngIf="editable" mat-button color="primary" appThrottleClick (throttledClick)="openEditor()">
          <mat-icon>edit</mat-icon> Edit
        </button>
      </div>
    </div>
    <div *ngIf="isEditing" class="attribute-editor-container">
      <attributes-editor
        [dataSource]="editorDataSource"
        [mode]="attributeEditorMode"
        [entityId]="entityId"
        (addOrUpdateComplexValue)="addOrUpdateComplexValue.emit($event)"
      ></attributes-editor>
      <div class="button-container">
        <button type="button" mat-button (mousedown)="preventDefault($event)" (click)="cancel()">
          <mat-icon>close</mat-icon> Close
        </button>
      </div>
    </div>
  </div>
</ng-container>
